
import React from 'react';
import { getRGB } from "../../lib/color";
import {get_div_bbox} from "../../lib/prm/bbox_utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {Popup} from "../../lib/onboarding-shared/popup";
import {DEVICE_WIDTH} from "../../lib/constants";
import {VimeoPopup} from "./vimeo";
import avatar_video_svg from "./avatar_video.svg";
import primer_video_svg from "./primer_video.svg";
import video_icon from "./video_icon.png";
import video_icon_3 from "./video_icon_3.png";
import {sprintf} from "sprintf-js";
import VideoIcon from '../components/VideoIcon/VideoIcon';

const Spinner = (props) => {
  const style = {
    ...(props && props.style),
  }
  if (props && props.size) {
    style.fontSize = props.size;
  }
  return (
    <i style={style} className="fa fa-circle-o-notch fa-spin login-spinner"/>
  );
};

const Search = props => {
  const style = {};
  if (props && props.size) {
    style.fontSize = props.size;
  }
  return (
    <i style={style} className="fa fa-search"/>
  );
}

const Times = props => {
  return (
    <i style={props.style} className="fa fa-times"/>
  );
};

const VIMEO_ICON_TYPE = {
  AVATAR: avatar_video_svg,
  PRIMER: primer_video_svg,
  VIDEO_ICON: video_icon,
  VIDEO_ICON_3: video_icon_3,
}

const VimeoIcon = props => {

  const over_id = props.id + "_over";
  const show_id = props.id + "_show";
  const component = props.component;

  const mouse_over = (over) => () => {
    if (component.state[show_id]) {
      return;
    }
    component.setState({
      [over_id]: over,
    })
  }
  const on_click = () => {
    component.setState({
      [show_id]: true,
      [over_id]: false,
    })
  }
  const on_dismiss = (ev) => {
    ev.stopPropagation();
    component.setState({
      [show_id]: false,
    })
  }

  const style = {
    display: "inline-block",
    ...props.style,
  }
//   const img_style = {
//     width: props.size || "4rem",
//     ...props.img_style,
//   }
  if (component.state[over_id]) {
    style.background = "#CCC";
    style.cursor = 'pointer';
  }
  const video_popup = component.state[show_id]
    ? (<VimeoPopup video_id={props.video_id} onDismiss={on_dismiss}/>) : null;

  return (
    <div
      align={"center"}
      style={{ ...style, display: 'flex', alignItems: 'center' }}
      onClick={on_click}
      onMouseOver={mouse_over(true)}
      onMouseOut={mouse_over(false)}>
      <div style={{ height: '50px', width: '50px' }}>
        {/* <img style={img_style} src={props.icon} alt={"vimeo_icon"}/> */}
        <VideoIcon />
      </div>
      { video_popup }
    </div>
  )
}

const Action = props => {
  const bg_mult = props.bg_mult || 1;
  const _button_style = {
    padding: "0.5rem 3rem",
    fontWeight: "bold",
    backgroundColor: sprintf("rgb(%d, %d, %d)", 239 * bg_mult, 239 * bg_mult, 239 * bg_mult),
    border: "1px solid rgb(118, 118, 118)",
    ...props.style,
  };

  const disable_props = {};
  if (props.disabled) {
    disable_props.disabled = true;
  }
  const on_enter_leave = (enter) => ev => {
    if (!props.onMouseEnter) {
      return;
    }
    props.onMouseEnter(props.id, enter);
  }

  return (
    <button
      id={props.id}
      style={_button_style}
      type={"button"}
      { ...disable_props}
      onMouseEnter={on_enter_leave(true)}
      onMouseLeave={on_enter_leave(false)}
      onClick={props.onClick}>
      { props.children }
    </button>
  )
}

const DashboardContainer = props => {
  const do_medium = props.device && props.device.width < DEVICE_WIDTH.medium;

  const div_style = {
    background: "#FFF",
    padding: do_medium ? "0.5rem" : "2rem",
    margin: do_medium ? "0.5rem" : "2rem",
    position: "relative",
    ...props.div_style,
  };
  const spinner_style = {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    position: "absolute",
    left: "0",
    top: "0",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }
  const spinner = props.spinner && (
    <div style={spinner_style}>
      <Spinner size={"3rem"}/>
    </div>
  );

  const title = props.title && (
    <DashTitle
      device={props.device}
      client={props.client}
      title={props.title}
      header={props.header}
      onTitleClick={props.onTitleClick}/>
  );

  return (
    <div style={div_style}>
      { title }
      { props.children }
      { spinner }
    </div>
  );
};

const DashTitle = (props) => {
  const client = props.client;
  const h1Style = {
    color: getRGB(client.color.sign_on_button),
    marginBottom: "0",
    whiteSpace: "nowrap",
    ...props.style,
  };
  const onClick = e => {
      if(!props.onTitleClick) { return }
      return props.onTitleClick(props.title);
  }

  const do_medium = props.device && props.device.width < DEVICE_WIDTH.medium;
  const button_class = do_medium ? "__title" : "title";

  const container_style = {
    display: "flex",
  }
  if (do_medium) {
    h1Style.fontSize = "1rem";
    h1Style.fontWeight = "bold";
    container_style.paddingBottom = "0.5rem";
  }
  return (
    <div style={container_style}>
      <button className={button_class} style={h1Style} onClick={onClick}>{props.title}</button>
      { props.header }
    </div>
  )
}

const HamburgerIcon = ({toggleHamburgerMenu, hamburgerContainerStyle}) => {
  return (
    <div className="hamburger-icon-container-responsive" style={hamburgerContainerStyle}>
      <button className="hamburger-icon-responsive" onClick={toggleHamburgerMenu}>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </button>
    </div>
  )
}

const GreyBox = props => {

  const div_style = {
    border: "1px solid #ddd",
    // top right bottom left
    padding: "1rem 1rem 1rem 1rem",
    backgroundColor: "#F7F7F7",
    ...props.style,
  }

  return (
    <div style={div_style}>
      { props.children }
    </div>
  )
}

/**
 * These are positioned in absolute mode, which means that the
 * rect is w.r.t. the nearest ancestor with position: relative.
 */
const HighlightRect = props => {

  const rect = props.rect;

  const div_style = {
    position: "absolute",
    display: "block",
    background: "rgba(255, 0, 0, 0.3)",
    width: rect.x_max - rect.x_min,
    height: rect.y_max - rect.y_min,
    top: rect.y_min,
    left: rect.x_min,
    borderRadius: "0.5rem",
    boxShadow: "0 0 1rem 0 red",
  }
  const container_ref = props.container_ref;
  if (container_ref.current) {
    const bbox = get_div_bbox(container_ref);
    div_style.top -= bbox.y_min;
    div_style.left -= bbox.x_min;
  }

  return (
    <div
      style={div_style}
      onClick={props.onClick}/>);
};

const HighlightRects = props => {
  return props.rects.map((rect, index) => {
    return (
      <HighlightRect
        key={index}
        rect={rect}
        container_ref={props.container_ref}
        onClick={props.onClick}
      />);
  });
}

const TextLoading = props => {
  const loading = props.loading;
  const label = props.label;
  const spinner_style = {
    visibility: loading ? "visible" : "hidden",
    width: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    ...props.spinner_style,
  }

  const container_style = {
    position: "relative",
    ...props.style,
  }
  return (
    <div style={container_style}>
      <span style={{visibility: loading ? "hidden" : "visible"}}>{label}</span>
      <div
        align={"center"}
        style={spinner_style}>
        <Spinner/>
      </div>
    </div>
  )
}

const Info = props => {

  const id = props.id + "_over";
  const component = props.component;

  const mouse_over = (over) => () => {
    component.setState({
      [id]: over,
    })
  }
  const style = {
    paddingLeft: "0.5rem",
    position: "relative",
    display: "inline-block",
    ...props.style,
  }
  const popup_style = {
    border: "solid 1px black",
    color: "black",
    padding: "0.5rem 1rem",
    ...props.popup_style,
  }

  const popup = component.state[id]
    ? (
      <Popup style={popup_style}>
        <span style={{fontSize: "1rem"}}>{ props.text}</span>
      </Popup>
    ) : null;

  return (
    <div
      style={style}
      onMouseOver={mouse_over(true)}
      onMouseOut={mouse_over(false)}>
      <FontAwesomeIcon icon={faInfoCircle}/>
      { popup }
    </div>
  );
}

const TitleText = props => {
  const style = {
    fontSize: "2.5rem",
    fontWeight: "800",
  }
  return (
    <div>
      <span style={style}>{props.children}</span>
    </div>
  )
}

export { Spinner, DashboardContainer, DashTitle, Action,
  HamburgerIcon, Times, GreyBox, HighlightRect, TextLoading,
  HighlightRects, Info, TitleText, VimeoIcon, VIMEO_ICON_TYPE,
  Search };
